import {
  Box,
  Button,
  Card,
  CardContent,
  Grid2,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MatchCard from "../../components/MatchCard";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CustomizedTable from "../../components/CustomizedTable";
import MatchDetailsCard from "../../components/MatchDetailsCard";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetMvpMatchDetailQuery,
  useLazyGetSpecificMatchDetailsQuery,
} from "../../services/matchAPI";
import useGetScoringData from "../Scoring/useGetScoringData";
import ScoreCardTable from "../../components/ScoreCardTable";
import { TeamA, TeamB } from "../../values/constants";
import { store } from "../../redux/store";
import { getToken } from "../../uttils/UserPref";
import { trimTrailingZeroes } from "../../uttils/common";
import { useSelector } from "react-redux";

const MatchDetails = (props) => {
  // const [getSpecificMatchDetails, { data: matchDetails }] =
  //   useLazyGetSpecificMatchDetailsQuery();

  const currentSelectedTab = useSelector(
    (state) => state.home.currentSelectedTab
  );
  const [liveTabSelected, setLiveTabSelected] = useState(true);
  const _selectTab = (live) => {
    live ? setLiveTabSelected(true) : setLiveTabSelected(false);
  };

  const navigate = useNavigate();

  const location = useLocation();
  const matchDetails = location?.state?.matchDetails;
  const matchId = matchDetails?._id;

  const [activeTab, setActiveTab] = useState(
    matchDetails?.isCompleted ? "Summary" : "Overview"
  );

  console.log("Match details", matchDetails, window.history);

  const {
    data: matchDetailsData,
    isLoading: matchDetailsLoading,
    refetch: refetchMatchDetails,
  } = useGetMvpMatchDetailQuery(
    {
      matchId,
      page: "match",
    },
    { refetchOnMountOrArgChange: true }
  );

  const matchOperations = {
    refetchMatchDetails,
    switchToSummary: () => setActiveTab("Summary"),
  };

  const { scoreData, loading, isRefetching, isDuck } = useGetScoringData(
    matchDetails?._id,
    matchOperations
  );

  const { wicketTypes } = store.getState();

  console.log("WEicket data", wicketTypes);

  let live;
  let scoreBoard;
  if (scoreData) {
    live = scoreData?.live;
    scoreBoard = scoreData?.scoreBoard;
  }

  console.log(scoreData, "Scoring data");

  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    // This will run when `myValue` changes
    if (currentSelectedTab !== "Matches") {
      navigate(-1); // Navigate back to the previous page
    }
  }, [currentSelectedTab, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
      }}
    >
      <Grid2 container>
        <Grid2 direction={"row"} size={{ xs: 12, sm: 12, md: 8 }}>
          <Grid2>
            <Stack
              mt={8}
              ml={4}
              direction={"row"}
              display={"flex"}
              sx={{ alignItems: "center" }}
            >
              <Typography variant="h6">Matches</Typography>

              <NavigateNextIcon sx={{ mt: 0.5, fontSize: "28px" }} />
              <Typography variant="h6">{matchDetails?.matchName}</Typography>
            </Stack>
            <Stack>
              <MatchCard
                onClick={() => {}}
                drawHeaderLine
                customStyles={{ ml: 4 }}
                item={matchDetails}
              />
            </Stack>
          </Grid2>
          <Stack m={4} direction={"row"} flex={1} spacing={2}>
            <Button
              sx={{ padding: "10px", textTransform: "initial" }}
              className={liveTabSelected ? "selectedTab" : "unSelectedTab"}
              onClick={() => _selectTab(true)}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "16px",
                  color: liveTabSelected ? "#fff" : "#000",
                }}
              >
                Live
              </Typography>
            </Button>
            <Button
              sx={{ padding: "10px", textTransform: "initial" }}
              className={!liveTabSelected ? "selectedTab" : "unSelectedTab"}
              onClick={() => _selectTab(false)}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "16px",
                  color: !liveTabSelected ? "#fff" : "#000",
                }}
              >
                Scorecard
              </Typography>
            </Button>
            <Stack
              display="flex"
              sx={{ flex: 1, justifyContent: "flex-end", alignItems: "center" }}
              flexDirection={"row"}
            >
              {!liveTabSelected && (
                <>
                  <Typography variant="subtitle1">TeamA</Typography>
                  <Switch
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                    color="default"
                  />
                  <Typography variant="subtitle1">TeamB</Typography>
                </>
              )}
            </Stack>
          </Stack>
          <Stack m={4} direction={"row"}>
            {liveTabSelected ? (
              <CustomizedTable live={live} />
            ) : (
              <ScoreCardTable
                live={live}
                scoreBoard={scoreBoard}
                currentActiveTab={!checked ? TeamA : TeamB}
                wicketTypes={wicketTypes?.data}
                teamName={
                  !checked
                    ? matchDetails?.teamA?.teamName
                    : matchDetails?.teamB?.teamName
                }
                totalRunsScored={
                  !checked
                    ? matchDetails?.teamA?.totalRuns
                    : matchDetails?.teamB?.totalRuns
                }
                totalOvers={
                  !checked
                    ? matchDetails?.teamA?.totalOvers
                    : matchDetails?.teamB?.totalOvers
                }
                totalWickets={
                  !checked
                    ? matchDetails?.teamA?.totalWicket
                    : matchDetails?.teamB?.totalWicket
                }
              />
            )}
          </Stack>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
          <Stack mr={4} mt={12}>
            <Stack>
              <Card
                variant="outlined"
                sx={{
                  m: 2,
                  borderRadius: "17px",
                }}
                onClick={() => {}}
              >
                <CardContent>
                  <Stack
                    display={"flex"}
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  >
                    {!live?.match?.overview?.isCompleted && (
                      <Stack>
                        <Typography variant="h6" sx={{ fontSize: "26px" }}>
                          CURRENT RUN RATE:{" "}
                          {trimTrailingZeroes(
                            live?.teamBatting?.teamScoreboard?.getRunRate()
                          )}
                        </Typography>
                        {live?.inning?.innings_number === 1 ? (
                          <Typography variant="h6" sx={{ fontSize: "26px" }}>
                            PROJECTED SCORE:{" "}
                            {trimTrailingZeroes(live?.getProjectedScore())}
                          </Typography>
                        ) : (
                          <Typography
                            variant="h6"
                            mt={0.8}
                            sx={{ fontSize: "26px" }}
                          >
                            REQUIRED RUN RATE:{" "}
                            {trimTrailingZeroes(
                              live?.teamBatting?.teamScoreboard?.getRequiredRunRate(
                                live?.match?.overview?.totalOvers,
                                live?.teamBowling?.teamScoreboard.getTotalRuns()
                              )
                            )}
                          </Typography>
                        )}
                      </Stack>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
            <MatchDetailsCard item={matchDetails} enableOnClick={false} />
          </Stack>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default MatchDetails;
